import React from 'react';
import { Formik } from 'formik';
import ServiceFormContainer from './ServiceFormContainer';
import { validationAddingService } from '../../utils/validations';
import './addServices.scss';

var Scroll = require('react-scroll');
var scroller = Scroll.scroller;

function AddServices(props) {
  const {
    flagEdit,
    item,
    evento,
    nElem,
    helper,
    helperTrue,
    helperFalse,
    getValues,
    handleIsLimit,
    listServices,
    setListServices,
    calculateProposalDetails
  } = props;

  const handleSubmit = async (
    values,
    { setSubmitting, setFieldError, resetForm }
  ) => {
    delete values.flagEdit
    delete values.item
    setSubmitting(false);
    if (flagEdit) {
      setSubmitting(false);
      let allServices = listServices
      allServices[item] = values.services[0]
      setListServices(allServices)
      calculateProposalDetails(allServices);
    } else {
      let allServices = values.services
      if (listServices && listServices.length !== 0) {
        allServices = [
          ...values.services,
          ...listServices,
        ]
      }
      setListServices(allServices)
      calculateProposalDetails(allServices);
    }
    resetForm();
    resetTab();
  };

  const formValues = {
    flagEdit: 1,
    services: flagEdit ? [listServices[item]] : [
      {
        description: '',
        price: 0,
        typeCurrency: 'MXN Peso mexicano',
        discount: '',
      }
    ],
  };

  const resetTab = () => {
    scroller.scrollTo('myScroll_Services', { smooth: true, offset: -64 });
    evento(false);
  };

  return (
    <div className="addServices">
      <Formik
        initialValues={formValues}
        onSubmit={handleSubmit}
        validationSchema={validationAddingService}
        render={props => (
          <ServiceFormContainer
            {...props}
            evento={resetTab}
            nElem={flagEdit ? item : nElem}
            helper={helper}
            helperTrue={helperTrue}
            helperFalse={helperFalse}
            getValues={getValues}
            handleIsLimit={handleIsLimit}
            edit={flagEdit}
          />
        )}
      />
    </div>
  );
}


export default AddServices;
